<div class="retention-timeline">
  <div class="chart">
    @if (view.hasSoftDeletion) {
      <div
        class="marker-label soft-delete"
        [class.align-end]="isNearEnd(view.softDeletionDate)"
        [class.align-start]="isNearStart(view.softDeletionDate)"
        [style.left.%]="percentageFor(view.softDeletionDate)"
      >
        <span class="name" translate="CALLS.EXTEND_RETENTION.TIMELINE_SOFT_DELETE"></span>
        <span class="date">{{ view.softDeletionDate | date: dateFormat }}</span>
      </div>
    }

    <div class="track" #track>
      <span class="segment retained" [style.width.%]="percentageFor(view.softDeletionDate)"></span>
      <span class="segment recoverable" [style.left.%]="percentageFor(view.softDeletionDate)" [style.width.%]="recoverableWidthPercentage"></span>
      <span class="dot meeting"></span>
      <!-- The deletion marker is drawn first so that the soft-deletion one stays on top of it, and so
           stays draggable, on the days the two of them sit on the same date. -->
      <span
        class="dot hard-delete"
        role="slider"
        tabindex="0"
        [attr.aria-label]="'CALLS.EXTEND_RETENTION.TIMELINE_HARD_SLIDER_LABEL' | translate"
        [attr.aria-valuemin]="0"
        [attr.aria-valuemax]="view.maximumDeletionExtensionInDays"
        [attr.aria-valuenow]="view.deletionExtensionInDays"
        [attr.aria-valuetext]="view.deletionDate | date: dateFormat"
        [style.left.%]="percentageFor(view.deletionDate)"
        (pointerdown)="startDragging($event, 'HARD')"
        (pointermove)="continueDragging($event)"
        (pointerup)="stopDragging()"
        (pointercancel)="stopDragging()"
        (keydown)="handleKeyDown($event, 'HARD')"
      ></span>
      @if (view.hasSoftDeletion) {
        <span
          class="dot soft-delete"
          role="slider"
          tabindex="0"
          [attr.aria-label]="'CALLS.EXTEND_RETENTION.TIMELINE_SOFT_SLIDER_LABEL' | translate"
          [attr.aria-valuemin]="0"
          [attr.aria-valuemax]="view.maximumSoftExtensionInDays"
          [attr.aria-valuenow]="view.softExtensionInDays"
          [attr.aria-valuetext]="view.softDeletionDate | date: dateFormat"
          [style.left.%]="percentageFor(view.softDeletionDate)"
          (pointerdown)="startDragging($event, 'SOFT')"
          (pointermove)="continueDragging($event)"
          (pointerup)="stopDragging()"
          (pointercancel)="stopDragging()"
          (keydown)="handleKeyDown($event, 'SOFT')"
        ></span>
      }
    </div>

    <div class="marker-label meeting">
      <span class="name" translate="CALLS.EXTEND_RETENTION.TIMELINE_CALL"></span>
      <span class="date">{{ view.meetingDate | date: dateFormat }}</span>
    </div>
    <div
      class="marker-label hard-delete"
      [class.align-end]="isNearEnd(view.deletionDate)"
      [class.align-start]="isNearStart(view.deletionDate)"
      [style.left.%]="percentageFor(view.deletionDate)"
    >
      <span class="name" translate="CALLS.EXTEND_RETENTION.TIMELINE_HARD_DELETE"></span>
      <span class="date">{{ view.deletionDate | date: dateFormat }}</span>
    </div>

    @if (view.maximumTotalDate !== null) {
      <div
        class="tick max-total"
        [class.align-end]="isNearEnd(view.maximumTotalDate)"
        [class.align-start]="isNearStart(view.maximumTotalDate)"
        [style.left.%]="percentageFor(view.maximumTotalDate)"
      >
        <span class="line"></span>
        <span class="caption">
          {{ 'CALLS.EXTEND_RETENTION.TIMELINE_MAXIMUM_TOTAL' | translate }} · {{ view.maximumTotalDate | date: dateFormat }}
          <mat-icon class="explain" [matTooltip]="view.maximumTotalTooltip" [attr.aria-label]="view.maximumTotalTooltip">info_outline</mat-icon>
        </span>
      </div>
    }
  </div>

  <div class="summary">
    @if (view.hasSoftDeletion) {
      <span class="extended soft-delete">
        <span translate="CALLS.EXTEND_RETENTION.TIMELINE_SOFT_EXTENDED_BY"></span>
        <span class="value">{{ softExtendedByLabel }}</span>
      </span>
    }
    <span class="extended hard-delete">
      <span translate="CALLS.EXTEND_RETENTION.TIMELINE_HARD_EXTENDED_BY"></span>
      <span class="value">{{ deletionExtendedByLabel }}</span>
    </span>
    <span class="limits">{{ view.limitsLabel }}</span>
  </div>
</div>
